/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { GridSortModel } from '@mui/x-data-grid';
import { ResourceType } from '../resources/resources.model';

export enum ResourceTagType {
  scholarship = 'scholarship',
  opportunity = 'opportunity',
  both = 'both',
}

export type ResourceTagContext = 'scholarships' | 'opportunities';

export interface ResourceTag {
  id: number;
  name: string;
  label: string;
  description: string;
  timesUsed: number;
  scholarshipCount: number;
  opportunityCount: number;
  createdAt: string;
  resourceType: ResourceTagType;
}

export interface CreateEditResourceTag {
  id?: number;
  name: string;
  description: string;
  resourceType: ResourceTagType;
  timesUsed?: number;
  createdAt?: string;
}

export interface ResourceTagListQueryParams {
  offset: number;
  limit?: number;
  search?: string;
  sortModel?: GridSortModel;
  for?: ResourceTagContext;
}

export const resourceTagTypeLabels: Record<ResourceTagType, string> = {
  [ResourceTagType.scholarship]: 'Scholarships',
  [ResourceTagType.opportunity]: 'Opportunities',
  [ResourceTagType.both]: 'Both',
};

export const resourceTagTypeOptions = Object.values(ResourceTagType).map((resourceType) => ({
  id: resourceType,
  label: resourceTagTypeLabels[resourceType],
}));

export const getTagContextForResourceType = (
  resourceType: ResourceType
): ResourceTagContext | undefined => {
  if (resourceType === ResourceType.scholarship || resourceType === ResourceType.tuition) {
    return 'scholarships';
  }

  if (resourceType === ResourceType.opportunity || resourceType === ResourceType.internship) {
    return 'opportunities';
  }

  return undefined;
};

export const isTagApplicableToResource = (
  tag: ResourceTag,
  resourceType: ResourceType
): boolean => {
  const isScholarshipContext =
    resourceType === ResourceType.scholarship || resourceType === ResourceType.tuition;

  if (isScholarshipContext) {
    return tag.resourceType === ResourceTagType.scholarship || tag.resourceType === ResourceTagType.both;
  }

  return tag.resourceType === ResourceTagType.opportunity || tag.resourceType === ResourceTagType.both;
};

export const getAvailableResourceTypeOptions = ({
  scholarshipCount,
  opportunityCount,
}: {
  scholarshipCount: number;
  opportunityCount: number;
}) => resourceTagTypeOptions.filter(({ id }) => {
  if (scholarshipCount > 0 && id === ResourceTagType.opportunity) {
    return false;
  }
  if (opportunityCount > 0 && id === ResourceTagType.scholarship) {
    return false;
  }
  return true;
});

export const EmptyResourceTag: ResourceTag = {
  id: 0,
  name: '',
  label: '',
  description: '',
  timesUsed: 0,
  scholarshipCount: 0,
  opportunityCount: 0,
  createdAt: '',
  resourceType: ResourceTagType.both,
};

export const ConstructResourceTag = (data: any): ResourceTag => {
  return {
    id: data.id,
    name: data.name,
    label: data.name,
    description: data.description,
    timesUsed: data.times_used ?? 0,
    scholarshipCount: data.scholarship_count ?? 0,
    opportunityCount: data.opportunity_count ?? 0,
    createdAt: data.created_at,
    resourceType: data.resource_type ?? ResourceTagType.both,
  };
};
